import zoomies from '../elements/zoomies.js';
zoomies.register();
